import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const FolderThemeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "FolderTheme",
    children: /*#__PURE__*/_jsx("path", {
      d: "M26.24 10.08H15.91a.52.52 0 0 1-.45-.38l-1.2-3.52a3.76 3.76 0 0 0-3.57-2.58H7.31c-1.61 0-3.04 1.03-3.56 2.55L2.2 10.84c-.13.38-.2.78-.21 1.18v12.6c0 2.07 1.68 3.76 3.76 3.76h20.49c2.07 0 3.76-1.68 3.76-3.76v-10.8c0-2.07-1.68-3.76-3.76-3.76Zm-21.7 4.14c-.19-.09-.36-.2-.51-.34-.85-.73-.95-2.01-.21-2.86.73-.85 2.01-.95 2.86-.21.03.02.05.05.08.07l11.46 7.58-2.17 3.34zm13.86 8.45c-.22.33-.66.42-1 .21a.7.7 0 0 1-.32-.46.73.73 0 0 1 .1-.54l1.54-2.39a.731.731 0 0 1 1.23.79l-1.55 2.41zm7.17 3.47h-.07c-.32 0-.63.05-.94.05h-.07c-.68.01-1.35-.04-2.02-.15h-.06c-.37-.06-.74-.15-1.09-.27-2.17-.72-2.34-2.82-.94-4.29s3.44-.49 4.12 1.7c.12.48.36.93.7 1.3.11.11.25.21.39.27.26.08.45.28.51.54.1.38-.14.77-.52.87h-.03v-.02Z"
    })
  }));
};